// extracted by mini-css-extract-plugin
export var productImage = "_o7-1";
export var viewLink = "_o7-2";
export var wishlistItem = "_o7-0";